import PropTypes from 'prop-types';
import React from 'react';

const iconClasses = {
  football(type, title) {return (<svg className={`football-match-event-svgicon football-match-event-icon-${type}`} viewBox="0 0 63 66" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <path d="M31.28 0C14.006 0 0 14.654 0 32.727 0 50.8 14.006 65.455 31.28 65.455c17.275 0 31.28-14.655 31.28-32.728C62.56 14.655 48.555 0 31.28 0zm6.188 62.02c-2.032.42-4.56.66-6.616.7-1.985-.03-3.922-.272-5.79-.706-.323-.086-.66-.18-1.024-.28L20.366 51.44l2.955-6.125h15.92l.085.17 2.91 6.112L38.68 61.71c-.4.114-.806.217-1.214.31zM21.29 4.608l8.637 6.183v9.15L19.25 29.39l-7.43-3.542-.626-.3-3.36-10.07c3.31-4.91 7.992-8.74 13.457-10.87zM54.675 15.43L51.3 25.576l-8.12 3.837-10.697-9.474v-9.15l8.662-6.202c5.468 2.122 10.21 5.94 13.53 10.842zM2.73 35.467l8.083-7.32 7.45 3.557.084.04 2.965 12.16-3.073 6.063-10.507-.144c-2.76-4.148-4.543-9.055-5.004-14.356zm41.59 14.5l-3.072-6.063 2.97-12.18 7.52-3.585 8.093 7.327c-.46 5.3-2.244 10.208-5.003 14.356l-10.506.144z" fillRule="evenodd"/>
    </svg>)},
  card(type, title) {return (<svg className={`football-match-event-svgicon football-match-event-icon-${type}`} viewBox="0 0 44 66" xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
      <rect x="1578" y="460" width="43.01" height="65.455" rx="2" transform="translate(-1578 -460)" fillRule="evenodd"/>
    </svg>)},
  text(type, title, text) {return (<span className={`football-match-event-texticon football-match-event-icon-${type}`} title={title}>{text}</span>)},
  subOff(type, title) {return (<svg  className={`football-match-event-svgicon football-match-event-icon-${type}`}viewBox="0 0 49 66" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <path d="M47.036 45.124L28.37 63.78c-1.032 1.117-2.437 1.675-3.983 1.675-1.547 0-2.934-.558-3.983-1.674L1.667 45.125c-2.223-2.213-2.223-5.822 0-8.035 2.222-2.214 5.813-2.214 8.035 0l8.96 8.964V5.692c0-3.144 2.542-5.692 5.69-5.692 3.146 0 5.688 2.548 5.688 5.692v40.362L39 37.09c2.222-2.214 5.813-2.214 8.036 0 2.222 2.212 2.222 5.802 0 8.034z"/>
    </svg>)},
  subOn(type, title) {return (<svg  className={`football-match-event-svgicon football-match-event-icon-${type}`}viewBox="0 0 49 66" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <path d="M20.328 1.674C21.358.558 22.762 0 24.308 0c1.547 0 2.933.558 3.982 1.674l18.732 18.65c2.222 2.213 2.222 5.82 0 8.033-2.22 2.213-5.81 2.213-8.033 0l-8.96-8.944v40.35c0 3.144-2.54 5.692-5.686 5.692s-5.687-2.548-5.687-5.69V19.412L9.7 28.376c-2.222 2.213-5.812 2.213-8.034 0-2.22-2.23-2.22-5.82 0-8.052l18.662-18.65z"/>
    </svg>)}
}


const icons = {
  "Unknown Type": <span/>,

  "Goal": iconClasses.football("goal", "Goal"),
  "Penalty": iconClasses.text("penalty", "Penalty Scored", "PEN"),
  "Yellow Card": iconClasses.card("yellow-card", "Yellow Card"),
  "Second Yellow Card":  iconClasses.card("second-yellow-card", "2nd Yellow Card"),
  "Red Card":  iconClasses.card("red-card", "Red Card"),
  "Full Time":  iconClasses.text("full-time", "Full Time", "FT"),
  "Half Time": iconClasses.text("half-time", "Half Time", "HT"),

  "Sub On": iconClasses.subOn("sub-on", "Sub On"),
  "Sub Off": iconClasses.subOff("sub-off", "Sub Off")
};

function FootballMatchEventIcon(props) {
  return icons[props.type] || icons["Unknown Type"];
}

FootballMatchEventIcon.propTypes = {
  type: PropTypes.string.isRequired
}

export default FootballMatchEventIcon



// WEBPACK FOOTER //
// ./modules/Football/components/svg/FootballMatchEventIcon.js